import { requestGet as wsRequestGet, requestPost as wsRequestPost, requestDelete as wsRequestDelete } from './_wsApiFetchData';

export async function getFacilityRedirect(id, language, timeZone, cancelToken) {
    return await wsRequestGet(`/admin/facilityredirects/${id}`, language, timeZone, null, cancelToken);
}

export async function searchFacilityRedirects({ filters }, language, timeZone, cancelToken) {
    // Clean up empty or undefined filter values
    const cleanFilters = filters ? Object.keys(filters).reduce((acc, key) => {
        const value = filters[key];
        if (key && value !== undefined && value !== 'undefined' && value !== '') {
            acc[key] = value;
        }
        return acc;
    }, {}) : {};

    return await wsRequestGet('/admin/facilityredirects/search', language, timeZone, Object.keys(cleanFilters).length > 0 ? cleanFilters : null, cancelToken);
}

export async function createFacilityRedirect(data, language, timeZone, cancelToken) {
    return await wsRequestPost('/admin/facilityredirects/create', language, timeZone, data, null, cancelToken);
}

export async function updateFacilityRedirect(data, language, timeZone, cancelToken) {
    return await wsRequestPost('/admin/facilityredirects/update', language, timeZone, data, null, cancelToken);
}

export async function deleteFacilityRedirect(id, language, timeZone, cancelToken) {
    return await wsRequestDelete(`/admin/facilityredirects/${id}`, language, timeZone, null, null, cancelToken);
}

export async function toggleActiveFacilityRedirect(id, language, timeZone, cancelToken) {
    return await wsRequestPost(`/admin/facilityredirects/${id}/toggle-active`, language, timeZone, null, null, cancelToken);
}
